import { render, staticRenderFns } from "./ticketLog.vue?vue&type=template&id=0a95089b&"
import script from "./ticketLog.vue?vue&type=script&lang=js&"
export * from "./ticketLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports